import axios from 'axios';
import moment from 'moment';

export default {
    namespaced: true,

    state: {
        hasPartnerEnteredAnotherSinglesTournament: false,
        hasPartnerEnteredAnotherDoublesTournament: false,
        checkingPartnerSingles: false,
        checkingPartnerDoubles: false,
        checkingPartnerSinglesError: null,
        checkingPartnerDoublesError: null,
    },

    getters: {
        hasPartnerEnteredAnotherSinglesTournament: (state) => state.hasPartnerEnteredAnotherSinglesTournament,
        hasPartnerEnteredAnotherDoublesTournament: (state) => state.hasPartnerEnteredAnotherDoublesTournament,
        checkingPartnerSingles: (state) => state.checkingPartnerSingles,
        checkingPartnerDoubles: (state) => state.checkingPartnerDoubles,
        checkingPartnerSinglesError: (state) => state.checkingPartnerSinglesError,
        checkingPartnerDoublesError: (state) => state.checkingPartnerDoublesError,
    },

    mutations: {
        setPartnerHasEnteredAnotherSinglesTournament(state, data) { state.hasPartnerEnteredAnotherSinglesTournament = data; },
        setPartnerHasEnteredAnotherDoublesTournament(state, data) { state.hasPartnerEnteredAnotherDoublesTournament = data; },

        startLoadingPartnerSinglesTournaments(state) { state.checkingPartnerSingles = true; },
        startLoadingPartnerDoublesTournaments(state) { state.checkingPartnerDoubles = true; },
        stopLoadingPartnerSinglesTournaments(state) { state.checkingPartnerSingles = false; },
        stopLoadingPartnerDoublesTournaments(state) { state.checkingPartnerDoubles = false; },

        clearLoadingPartnersSinglesTournamentsError(state) { state.checkingPartnerSinglesError = null; },
        clearLoadingPartnersDoublesTournamentsError(state) { state.checkingPartnerDoublesError = null; },
        setLoadingPartnersSinglesTournamentsError(state, error) { state.checkingPartnerSinglesError = error; },
        setLoadingPartnersDoublesTournamentsError(state, error) { state.checkingPartnerDoublesError = error; },
    },

    actions: {
        async checkPartnerSingles(context, options) {
            context.commit('startLoadingPartnerSinglesTournaments');
            context.commit('clearLoadingPartnersSinglesTournamentsError');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/HasPartnerEnteredAnotherSinglesTournamentTheSameWeek/${options.startDate}/${options.tournNbr}/${options.partnerNbr}`);
                context.commit('setPartnerHasEnteredAnotherSinglesTournament', result.data);
                context.commit('stopLoadingPartnerSinglesTournaments');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingPartnersSinglesTournamentsError', error);
                context.commit('stopLoadingPartnerSinglesTournaments');
                return Promise.reject(error);
            }
        },
        async checkPartnerDoubles(context, options) {
            context.commit('startLoadingPartnerDoublesTournaments');
            context.commit('clearLoadingPartnersDoublesTournamentsError');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/HasPartnerEnteredADoublesTournamentInWeek/${options.startDate}/${options.partnerNbr}`);
                context.commit('setPartnerHasEnteredAnotherDoublesTournament', result.data);
                context.commit('stopLoadingPartnerDoublesTournaments');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingPartnersDoublesTournamentsError', error);
                context.commit('stopLoadingPartnerDoublesTournaments');
                return Promise.reject(error);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/doubles/partner-checks.js